import React from "react";
import {Switch,Route} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent"; 

const Reports =({match})=>(
    <Switch>
          <Route  path={`${match.url}/AssetReport`} component={asyncComponent(()=>import( './AssetReport/index'))} />
          <Route path={`${match.url}/AssetRemainingDepreciationReport`} component={asyncComponent(() => import('./AssetRemainingDepreciationReport/index'))} />
          <Route path={`${match.url}/AssetAuxiliaryReport`} component={asyncComponent(() => import('./AssetDepreciationAuxiliaryReport/index'))} />
    </Switch>
)
export default Reports;
